import {useCallback, useEffect, useRef} from 'react';

const isTouchable = 'ontouchstart' in document.documentElement;

export function useOutsideDetector(enabled: boolean, callback: () => void) {
    const callbackRef = useRef<() => void>();
    const ref = useRef(null);

    useEffect(() => {
        callbackRef.current = callback;
    });

    const handleClickOutside = useCallback((e: Event) => {
        if (!enabled) {
            return;
        }

        if (ref.current && !ref.current.contains(e.target)) {
            callbackRef.current();
        }
    }, [enabled]);

    useEffect(() => {
        document.body.addEventListener(isTouchable ? 'touchstart' : 'mousedown', handleClickOutside);
        return () => {
            document.body.removeEventListener(isTouchable ? 'touchstart' : 'mousedown', handleClickOutside);
        };
    }, [handleClickOutside]);
    return ref;
}
